module.exports = __webpack_public_path__ + "img/down-arrow-brown.476861ce.svg";